import { createFileRoute } from '@tanstack/react-router';

import { PersonalizationScreen } from '@/screens/onboarding/PersonalizationScreen';

export const Route = createFileRoute('/_onboarding/onboarding/personalization')({
  component: PersonalizationScreen,
});
